import './FieldButton.css';

import { cn } from '##/utils/bem';

export const cnFieldButton = cn('FieldButton');
